export default __webpack_public_path__ + "static/media/039-cooking pot.2cca90c8.svg";